import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';
import Icon from '../Icon/Icon';

const DefaultTagRenderer = ({ tag, children, className, disabled, onClick, ...rest }) =>
  <span key={tag} aria-label="tag" data-tag={tag} className={cx('core-tag', className, { disabled, removable: onClick })} onClick={onClick} {...rest}>
    {children}
    {tag}
    {onClick && <Icon aria-label="tag-close-icon" name="close"/>}
  </span>;

DefaultTagRenderer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

DefaultTagRenderer.displayName = 'DefaultTagRenderer';

export default DefaultTagRenderer;
